import IconSVG from 'svg-inline-react'
import { Button } from '@driftt/tide-core-legacy'
import upsellLogos from 'images/upsell/upsell-logos@2x.png'
import calendar from 'images/upsell/cal-connect.png'
import header from '!svg-inline?removeTags=true!images/upsell/sequences-upsell-header.svg'
import close from '!svg-inline?removeTags=true!images/svg/onboarding/close.svg'

import './styles.styl'

const MeetingTripWireModal = ({ setShowTripwire }) => <div className="tripwire-modal-lightbox">
  <div className="two-panel-modal">
    <div className="left-panel-content">
      <div>
        <IconSVG className="info" src={header} />
        <div className="helper-text">Book meetings faster right from this email sequence. Share your calendar in this automated sequence and let people book meetings with you in 1-click.</div>
        <div className="education-button-wrapper">
          <Button href="/settings/billing" target="_blank" className="upgrade-button">Upgrade Account</Button>
          <Button className="learn-more" href="https://www.drift.com/meetings" target="_blank" type="subtle">Learn More</Button>
        </div>
      </div>
    </div>
    <div className="right-panel-content">
      <div className="calendar-preview">
        <IconSVG className="onboarding-close" src={close} onClick={() => setShowTripwire(false)} />
        <img src={calendar} alt="calendar"/>
      </div>
    </div>
    <img className="upsell-logos" src={upsellLogos} />
  </div>
</div>

export default MeetingTripWireModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/MeetingTripwire/index.js